// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"d0a6eaf9a213b9f3","408":"7534861b0c43be67"}[chunkId] + ".css";
};